import React, { useRef, useState } from 'react';
import { Form } from '@tribeplatform/react-components/Form';
import { T } from '@tribeplatform/react-components/i18n';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { Modal } from '@tribeplatform/react-ui-kit/Modal';
import { FormCodeEditor } from './FormCodeEditor.js';
export const CodeEditorFieldPicker = ({ label, value: initialValue, onChange, name, defaultLanguage, }) => {
    const [open, setOpen] = useState(false);
    const formRef = useRef();
    const close = () => {
        formRef.current.methods.reset({ [name]: initialValue });
        setOpen(false);
    };
    return (React.createElement(Form, { defaultValues: { [name]: initialValue }, ref: formRef },
        React.createElement(FormControl, null,
            label && React.createElement(FormControl.Label, null, label),
            React.createElement("div", { className: "hover:outline hover:border-focused hover:ring-focused flex cursor-pointer relative shadow-sm px-3 py-2 border w-full rounded-md text-content-subdued bg-surface border-line-subdued max-h-32 overflow-auto", onClick: () => setOpen(true) },
                React.createElement("p", { className: "text-content-subdued" },
                    React.createElement(T, { id: "Blocks.HtmlScript.ClickToInsertText", defaultMessage: "Click to insert html text in this block" }))),
            React.createElement("small", { className: "text-content-subdued" },
                React.createElement(T, { id: "Blocks.HtmlScript.EditorSizeNote", defaultMessage: "Note that due to editor size, your html code might be a little different visually from what you see on the live {COMMUNITY}" }))),
        React.createElement(Modal, { showZenModeBtn: true, onClose: close, open: open, closeOnBackdropClick: false },
            React.createElement("div", { className: "flex flex-col w-full h-full sm:m-0 justify-between" },
                React.createElement(Modal.Header, { title: React.createElement(T, { id: "Blocks.HtmlScript.EditSeomthingButton", defaultMessage: "Edit {name}", values: { name } }), className: "mx-auto w-full" }),
                React.createElement(Modal.Content, { className: "mx-auto flex-1 w-full" },
                    React.createElement(FormCodeEditor, { name: name, style: {
                            minHeight: '250px',
                        }, className: "h-full", defaultLanguage: defaultLanguage, onChange: value => {
                            formRef.current.methods.setValue(name, value);
                        } })),
                React.createElement(Modal.Footer, { className: "flex justify-end mx-auto w-full space-s-2" },
                    React.createElement(Button, { variant: "outline", onClick: close },
                        React.createElement(T, { id: "Generics.Close", defaultMessage: "Close" })),
                    React.createElement(Button, { onClick: () => {
                            setOpen(false);
                            const currValue = formRef.current.methods.getValues()[name];
                            onChange(currValue);
                        } },
                        React.createElement(T, { id: "Generics.Save", defaultMessage: "Save" })))))));
};
//# sourceMappingURL=CodeEditorFieldPicker.js.map